module.exports = __webpack_public_path__ + "static/loading-c9a475e5cd7606981d531b14de4fe5ea.gif";